import React, { Component } from 'react';
import { socketConnect } from 'socket.io-react';
import PropTypes from 'prop-types';
import Modal from 'components/Modal';
import InputValidation from 'components/InputValidation';
import { browserHistory,Link } from 'react-router';
import LogoImage from 'assets/megafit-images/mf-logo.svg';
import LeftArrow from 'assets/btn-left-arrow.png';
import bannerSignin from 'assets/megafit-images/sign-banner.png';

class Restore extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      errors: {},
      showModal: false,
      modalMessage: '',
      xyz: false
    };
  }

  listener = action => {
    if (this.RestoreRef) {
      if (action.type === 'tryOk') {
        this.setState({
          showModal: true,
          modalMessage: (
            <div>
              <h3>Email sent!</h3>
              <p>{action.message}</p>
              <p> In case of any difficulties please reach us on <a href="tel:+9710503341963" class="tel">050-334-1963</a></p>
            </div>
          )
        });
      } else if (action.type === 'tryErr') {
        console.log('restore error');
        this.setState({ errors: action.errors });
      }
    }
  };

  componentWillMount() {
    this.props.socket.on('restore_password', this.listener);
  }

  componentWillUnmount() {
    this.props.socket.removeListener('restore_password', this.listener);
  }

  componentDidMount() {
    setTimeout(() => this.setState({ xyz: true }), 10);
  }

  submit(e) {
    e.preventDefault();
    const data = {
      email: this.state.email
    };
    this.props.socket.emit('restore_password', { type: 'try', data: data });
  }

  render() {
    const { errors, showModal, modalMessage, xyz } = this.state;
    const onChange = (name, value) => this.setState({ [name]: value });
    return (
      <div ref={el => (this.RestoreRef = el)} className={`mf-container reset-page forgetpwd-page`}>
      <div className='full-width'>   
        <div className='sign-container'>
        <div className='sign-left'>
        <Link to='/checkout' ><img src={bannerSignin} alt='Megafit-Banner' /></Link>
        {/* <img src={bannerSignin} alt='Megafit-Banner' />
            <div className='sign-left-inner '>
              <div class="flex-container">
                <div class="sign-content-left">
                  <h1> 
                    <span class="mainSpan"><span class="small-txt">Customize</span><span class="normal-txt"> Your Fuel,</span></span>
                    <span class="mainSpan"><span class="small-txt">Maximize</span><span class="normal-txt"> Your Gains</span></span>
                  </h1>
                </div>
                <div class="sign-content-right">
                  <p>Make you own Macro <br/>Counted Meals with</p>
                  <span class="yellow-box"><strong>MegaFit</strong> CustomFit<sup>®</sup></span>
                </div>    
              </div>
            </div> */}
        </div>
        <div className={`sign-right`}>
        <div className='logo'>  <Link to='/' onClick={() => stop()} onlyActiveOnIndex><img src={LogoImage} alt='MegaFit' /></Link></div>
        <div className='sign-up-form signinform resetform'>
          <div class='sign-in-top mt-1'><span class='colorTitle'>Trouple with logging in?</span></div>
          <div className='search-title mt-1'>
            <span className='colorTitle'>Enter your registered email address and we'll send you a link to get back into your account</span>
          </div>
          <form className='form' onSubmit={e => this.submit(e)}> 
            <div className='sign-up-input mt-4 email-field'>
              <InputValidation
                name='email'
                value={this.state.email}
                onChange={onChange}
                placeholder={'E-mail address'}
                className={`form-input ${'email' in errors ? 'has-error' : ''}`}
                errors={errors}
                inputSelfClassName='standart-input b-rounded-blue'
              />
            </div>
            <div className='sign-up-input my-4 sign-up-button d-flex align-items-center justify-content-around'>
              <input type='submit' value='Send Login Link' className='letter-sm w-100' />
            </div>
            <div className='mt-4 mr-1 text-center'>
               <span className='login-text'><img src={LeftArrow} alt='Back' /> <Link to='/sign-in'>Back</Link></span>
            </div>
          </form>
          <div className='search-title login-text mt-3 color-transparent'>
            <p className='line-height-xsnormal login-text mb-0 color-transparent'>
              By signing in or signing up, I agree to <strong>MegaFit</strong>&nbsp;
              <Link to='/terms' >Terms & Conditions</Link>, <Link to='/refunds' >Refund & Cancellation policy</Link>, <Link to='/privacy-policy' >Privacy Policy</Link>,
              I confirm that I am 18 years of age or older, and consent to receiving email communication.
            </p>
            </div>
        </div>
        {showModal &&
          <Modal
            close={() => {
              this.setState({ showModal: false });
              browserHistory.push('/sign-in');
            }}
            message={modalMessage}
            headLine="Password Reset"
          />
        }
      </div>
      </div>
      </div>
      </div>
    );
  }
}

Restore.propTypes = {
  socket: PropTypes.object.isRequired
};

export default socketConnect(Restore);